import { api } from '@/lib/api';
import type { IApiResponse, ILogQuery, ILogResponse } from '@skystone/shared';

export const logApi = {
  getLogs: async (query: ILogQuery): Promise<ILogResponse> => {
    const params = new URLSearchParams();
    if (query.level) params.set('level', query.level);
    if (query.search) params.set('search', query.search);
    if (query.source) params.set('source', query.source);
    if (query.limit) params.set('limit', String(query.limit));
    const qs = params.toString();
    const url = qs ? `/admin/logs?${qs}` : '/admin/logs';
    const result = await api.get<IApiResponse<ILogResponse>>(url);
    return result.data;
  },
};
